var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2685,
	"./chat-icon-bottom-nav-mobile.webp": 2686,
	"./home-icon-bottom-nav-mobile-active.webp": 2687,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2688,
	"./home-icon-bottom-nav-mobile.webp": 2689,
	"./home-icon-bottom-nav-mobile_b.webp": 2690,
	"./me-icon-bottom-nav-mobile-active.webp": 2691,
	"./me-icon-bottom-nav-mobile.webp": 2692,
	"./promo-icon-bottom-nav-mobile-active.webp": 2693,
	"./promo-icon-bottom-nav-mobile.webp": 2694,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2695,
	"./sponsor-icon-bottom-nav-mobile.webp": 2696,
	"./stream-icon-bottom-nav-mobile-active.webp": 2697,
	"./stream-icon-bottom-nav-mobile.webp": 2698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2684;